import { Injectable } from '@angular/core';
import { PlacePredictionDto, PlacesApiService } from '@fleet-beat/api';
import { BaseDataSourceServiceV2, PageableListV2Dto, SnackbarService } from '@fleet-beat/core';
import { DataAutocompleteStorageParams } from '@fleet-beat/editor';
import { AuthService } from '@fleet-beat/shared';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AddressAutocompleteStorageService extends BaseDataSourceServiceV2<
  PlacePredictionDto,
  DataAutocompleteStorageParams<object>
> {
  constructor(
    protected override snackbarService: SnackbarService,
    private authService: AuthService,
    private placesApiService: PlacesApiService,
  ) {
    super(snackbarService);
  }

  protected override getData(
    data: DataAutocompleteStorageParams<object>,
  ): Observable<PageableListV2Dto<PlacePredictionDto>> {
    if (!data.params.input) {
      return of({ data: [], offset: undefined, limit: undefined, total: 0 });
    }

    return this.placesApiService.getMany(data, this.authService.authHeaders);
  }

  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  protected override getById(id: string): Observable<PlacePredictionDto> {
    throw new Error('Not Implemented');
  }
}
